var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaestroCardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 20,
    viewBox: "0 0 30 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 20,
    rx: 2,
    fill: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7043 14.9622H12.2949V5.31287H17.7043V14.9622Z",
    fill: "#6C6BBD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6415 10.1368C12.6415 8.17934 13.5648 6.43571 15.0027 5.31208C13.9512 4.49043 12.6242 4 11.182 4C7.7677 4 5 6.74749 5 10.1368C5 13.526 7.7677 16.2735 11.182 16.2735C12.6242 16.2735 13.9512 15.7831 15.0027 14.9614C13.5648 13.8378 12.6415 12.0941 12.6415 10.1368Z",
    fill: "#EB001B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0002 10.1368C25.0002 13.526 22.2325 16.2735 18.8182 16.2735C17.376 16.2735 16.0489 15.7831 14.9971 14.9614C16.4353 13.8378 17.3587 12.0941 17.3587 10.1368C17.3587 8.17934 16.4353 6.43571 14.9971 5.31208C16.0489 4.49043 17.376 4 18.8182 4C22.2325 4 25.0002 6.74749 25.0002 10.1368Z",
    fill: "#0099DF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaestroCardIcon);
export default __webpack_public_path__ + "static/media/maestro-card-icon.b0068519100c10268b4d335b2860fcd2.svg";
export { ForwardRef as ReactComponent };